import { Box, Grid } from "@mui/material";
import HarshEventPopup from "../../components/Fleet/HarshEvent/HarshEventPopup/HarshEventPopup";
import HarshEventsTable from "../../components/Fleet/HarshEvent/HarshEventsTable/HarshEventsTable";

const HarshEventsPage = () => {
  return (
    <Box className="harsh-events-page">
      <Grid container spacing={1} alignItems="center" justifyContent="center">
        <Grid
          item
          xs={12}
          display="flex"
          justifyContent="space-between"
          alignItems="center"
        >
          <Box
            sx={{
              flexWrap: { xs: "wrap", lg: "nowrap" },
              flex: 1,
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Grid
              container
              spacing={1}
              justifyContent="center"
              sx={{ maxWidth: "800px" }}
            >
              <Grid item>
                <HarshEventPopup />
              </Grid>
            </Grid>
          </Box>
        </Grid>
      </Grid>
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <HarshEventsTable />
        </Grid>
      </Grid>
    </Box>
  );
};

export default HarshEventsPage;
